import React, { FC } from 'react';
import { Menu, Drawer } from 'antd';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Permissions } from '../../../shared/models/permissions.enum';
import { UseHaveAnyPermissions } from '../../../Auth/UseHaveAnyPermissions';

const { SubMenu } = Menu;

type Props = {
  showMenu: boolean;
  hideMenu: () => void;
};

export const MenuDrawer: FC<Props & RouteComponentProps> = ({ showMenu, hideMenu, history }) => {
  const hasStandardPermission = UseHaveAnyPermissions([Permissions.AnnotationManager_AnnotationStandardAdministration]);
  const hasTemplatePermission = UseHaveAnyPermissions([Permissions.AnnotationManager_AnnotationStandardTemplateAdministration]);

  const goToFindingTypePropertyTemplates = () => {
    history.push('/annotation-manager/finding-type-property-template');
    hideMenu();
  };

  const goToFindingTypeTemplates = () => {
    history.push('/annotation-manager/finding-type-template');
    hideMenu();
  };

  const goToFailureMechanismTemplates = () => {
    history.push('/annotation-manager/failure-mechanism-template');
    hideMenu();
  };

  const goToAnnotationStandards = () => {
    history.push('/annotation-manager/annotation-standards');
    hideMenu();
  };

  const goToAnnotationManager = () => {
    history.push('/annotation-manager');
    hideMenu();
  };

  const goToMaintenanceTriggers = () => {
    history.push('/maintenance-triggers');
    hideMenu();
  };

  const goToFailureModeCategoryTemplates = () => {
    history.push('/annotation-manager/failure-mode-category-template');
    hideMenu();
  };

  const goToEightDTemplates = () => {
    history.push('/annotation-manager/eight-d-template');
    hideMenu();
  };

  if (hasStandardPermission || hasTemplatePermission) {
    return (
      <Drawer title='Annotation Module' placement='left' closable={true} onClose={hideMenu} visible={showMenu} width='300'>
        <Menu className='side-menu' mode='inline'>
          <Menu.Item key='1' onClick={() => goToAnnotationManager()}>
            Annotation Module
          </Menu.Item>
          {hasStandardPermission && (
            <Menu.Item key='2' onClick={() => goToAnnotationStandards()}>
              Annotation Standard
            </Menu.Item>
          )}
          {hasTemplatePermission && (
            <SubMenu key='sub2' title={<span>Templates Administration</span>}>
              <Menu.Item key='4' onClick={() => goToFindingTypeTemplates()}>
                Finding Type
              </Menu.Item>
              <Menu.Item key='5' onClick={() => goToFindingTypePropertyTemplates()}>
                Property
              </Menu.Item>
              <Menu.Item key='6' onClick={() => goToFailureMechanismTemplates()}>
                Failure Mechanism
              </Menu.Item>
              <Menu.Item key='7' onClick={() => goToFailureModeCategoryTemplates()}>
                Failure Mode Category
              </Menu.Item>
              <Menu.Item key='8' onClick={() => goToEightDTemplates()}>
                8D
              </Menu.Item>
            </SubMenu>
          )}
          <Menu.Item key='3' onClick={() => goToMaintenanceTriggers()}>
            Maintenance Triggers
          </Menu.Item>
        </Menu>
      </Drawer>
    );
  }

  return null;
};

export default withRouter(MenuDrawer);
